/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// 标签管理

// 列表
export function tagIndexList(query) {
    return axios({
        url: "/admin/cate/cate/index",
        method: "get",
        params: query
    });
}

// 添加/修改
export function tagEdit(query) {
    return axios({
        url: "/admin/cate/cate/edit",
        method: "post",
        params: query
    });
}

// 获得所有标签内容
export function tagAllList(query) {
    return axios({
        url: "/admin/cate/cate/alllist",
        method: "post",
        params: query
    });
}

// 添加首页标签
export function addhometag(query) {
    return axios({
        url: "/admin/cate/cate/addhometag",
        method: "post",
        params: query
    });
}

// 清除所有首页标签
export function removehomtag(query) {
    return axios({
        url: "/admin/cate/cate/removehomtag",
        method: "post",
        params: query
    });
}

